// Services.js
import React, { useState, useCallback } from 'react';
import styles from './Services.module.css';
import { FaDesktop, FaCalendarCheck } from 'react-icons/fa';

// Throttle function from the website
function throttle(func, delay) {
  let lastCall = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return func(...args);
  };
}

// Custom hook for tilt effect from the website
const useTiltEffect = () => {
  const [rotate, setRotate] = useState({ x: 0, y: 0 });

  const onMouseMove = useCallback(
    throttle((e) => {
      const card = e.currentTarget;
      const box = card.getBoundingClientRect();
      const x = e.clientX - box.left;
      const y = e.clientY - box.top;
      const centerX = box.width / 2;
      const centerY = box.height / 2;
      const rotateX = (y - centerY) / 15;
      const rotateY = (centerX - x) / 15;
      setRotate({ x: rotateX, y: rotateY });
    }, 100),
    []
  );

  const onMouseLeave = () => {
    setRotate({ x: 0, y: 0 });
  };

  return { rotate, onMouseMove, onMouseLeave };
};

// Individual card component with tilt effect
const ServiceCard = ({ icon, title, description }) => {
  const { rotate, onMouseMove, onMouseLeave } = useTiltEffect();

  return (
    <div 
      className={styles.card}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      style={{
        transform: `perspective(1000px) rotateX(${rotate.x}deg) rotateY(${rotate.y}deg) scale3d(1, 1, 1)`,
        transition: "all 400ms cubic-bezier(0.03, 0.98, 0.52, 0.99) 0s",
        willChange: "transform"
      }}
    >
      {icon}
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className={styles.servicesWrapper}>
      <div className={styles.services}>
        <h2>Everything You Need to Grow Your Music Studio</h2>
        <div className={styles.cards}>
          <ServiceCard 
            icon={<FaDesktop size={40} className={styles.icon}/>}
            title="AI-Generated Website"
            description="Get a stunning, professional website created by AI in just days. Our intelligent system analyzes your teaching style and creates a site that showcases your talent and attracts serious students and parents."
          />
          <ServiceCard 
            icon={<FaCalendarCheck size={40} className={styles.icon}/>}
            title="Smart Scheduling System"
            description="Eliminate scheduling headaches forever. Students and parents can book lessons directly on your site, with automatic Google Calendar sync to prevent double-bookings and keep you perfectly organized."
          />
        </div>
      </div>
    </section>
  );
};

export default Services;